import React, { useContext } from "react";
import { useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";

import { Save } from "@mui/icons-material";
import { Button, Table, TableBody } from "@mui/material";

import { Input } from "../../../../api/types/inputs";
import { useTooltips } from "../../api/useTooltips";
import { CafsContext } from "../../CafsContext";
import { CafsSection } from "../../const/cafs-section";

import { InputFormRow } from "./InputFormRow";

type InputFormProps = {
  data: Input;
};

export function InputForm({ data }: InputFormProps) {
  const { isReadMode } = useContext(CafsContext);
  const {
    formState: { isDirty, isValid },
  } = useFormContext();

  const { tooltips } = useTooltips(
    {
      EnglishName: data.EnglishName,
      FormerRecName: data.FormerRecName,
      NameSuffix: data.NameSuffix,
      ConfidentialSuffix: data.ConfidentialSuffix,
      GeneralRemarks: data.GeneralRemarks,
    },
    CafsSection.Input,
  );

  return (
    <>
      <Table
        sx={{
          minWidth: 650,
          border: "1px solid #CED4DA",
          borderBottom: "none",
        }}
        stickyHeader
        aria-label="simple base-table">
        <TableBody>
          <InputFormRow
            data={data}
            name="EnglishName"
            tooltip={tooltips?.EnglishName}
            isReadMode={isReadMode}
          />

          <InputFormRow
            data={data}
            name="FormerRecName"
            tooltip={tooltips?.FormerRecName}
            isReadMode={isReadMode}
          />

          <InputFormRow
            data={data}
            name="NameSuffix"
            tooltip={tooltips?.NameSuffix}
            isReadMode={isReadMode}
          />

          <InputFormRow
            data={data}
            name="ConfidentialSuffix"
            tooltip={tooltips?.ConfidentialSuffix}
            isReadMode={isReadMode}
          />

          <InputFormRow
            data={data}
            name="GeneralRemarks"
            tooltip={tooltips?.GeneralRemarks}
            rows={6}
            isReadMode={isReadMode}
          />
        </TableBody>
      </Table>
      <div className="mt-8">
        <Button
          type="submit"
          variant="contained"
          color="primary"
          startIcon={<Save />}
          disabled={!isDirty || !isValid || isReadMode}>
          <FormattedMessage
            id="APP.SAVE"
            defaultMessage="Save"
            description="General sace text"
          />
        </Button>
      </div>
    </>
  );
}
